import { Injectable } from '@angular/core';

// Flight Fare Summary toggle, shared across booking → review → payment; cleared when the booking completes
export const FARE_SUMMARY_VISIBLE_KEY = 'flight_fare_summary_visible';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  STORAGE_KEY = 'BTA-';
  constructor() { }

  setLocalStorageItem(key: string, value: any) {
    localStorage.setItem(`${this.STORAGE_KEY}${key}`, JSON.stringify(value));
  }

  getLocalStorageItem(key: string) {
    return localStorage.getItem(`${this.STORAGE_KEY}${key}`)
      ? JSON.parse(localStorage.getItem(`${this.STORAGE_KEY}${key}`) as any)
      : '';
  }

  clearLocalStorage() {
    localStorage.clear();
  }

  removeLocalStorageValue(key: string) {
    localStorage.removeItem(key);
  }

  setSessionStorageItem(key: string, value: any) {
    sessionStorage.setItem(`${this.STORAGE_KEY}${key}`, JSON.stringify(value));
  }

  getSessionStorageItem(key: string) {
    return sessionStorage.getItem(`${this.STORAGE_KEY}${key}`)
      ? JSON.parse(sessionStorage.getItem(`${this.STORAGE_KEY}${key}`) as any)
      : '';
  }

  clearSessionStorage() {
    sessionStorage.clear();
  }

  removeSessionStorageValue(key: string) {
    sessionStorage.removeItem(`${this.STORAGE_KEY}${key}`);
  }

  removeLocalStorageByKey(key: string) {
    localStorage.removeItem(`${this.STORAGE_KEY}${key}`);
  }

  /**
   * Recent searches (as in eth-b2b): the full search, newest first, at most 5, without
   * duplicates. `formData` (the search form's values) is ignored when comparing.
   */
  setLastSearched(searchDetails: any, module?: string): void {
    const key = module === 'hotel' ? 'search-history-hotel' : 'search-history';
    let searchResults: any[] = this.getLocalStorageItem(key) || [];

    searchResults = searchResults.filter(result => {
      const { formData, ...restResult } = result || {};
      const { formData: _ignored, ...restSearch } = searchDetails || {};
      return JSON.stringify(restResult) !== JSON.stringify(restSearch);
    });

    if (searchResults.length >= 5) {
      searchResults = searchResults.slice(0, 4);
    }

    searchResults.unshift(searchDetails);
    this.setLocalStorageItem(key, searchResults);
  }

  checkPermission(...args: string[]): boolean {

    let permissions = JSON.parse(
      JSON.stringify(this.getLocalStorageItem('permissions'))
    );
    if (args.length < 2) return false;

    let current = permissions;

    for (let i = 0; i < args.length - 1; i++) {
      if (!current || typeof current !== 'object' || !(args[i] in current)) {
        return false;
      }
      current = current[args[i]];
    }

    const operation = args[args.length - 1];
    return !!current?.[operation];
  }

  // checkPermission('flight', 'create'); // true
  // checkPermission('flight', 'queues', 'cancelled bookings', 'edit'); // true
  // checkPermission('hotel', 'queues', 'failed bookings', 'delete'); // true
  // checkPermission('hotel', 'queues', 'nonexistent', 'edit'); // false
}
